import { render } from "./TokenApisPage.vue?vue&type=template&id=fb38950e&scoped=true"
import script from "./TokenApisPage.vue?vue&type=script&lang=js"
export * from "./TokenApisPage.vue?vue&type=script&lang=js"

import "./TokenApisPage.vue?vue&type=style&index=0&id=fb38950e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb38950e"]])

export default __exports__